<script>
	import SoundMute from '../../../assets/sound_mute.svelte';
	import Sound from '../../../assets/sound.svelte';
	export let height;
	export let onClick = (data) => {};
	export let onMouseDown = () => {};
	export let isSoundOn = false;

	const internalHandler = () => {
		isSoundOn = !isSoundOn;
		onClick(isSoundOn);
	};
</script>

<div
	class="sound-Btn"
	on:click={internalHandler}
	on:mousedown={onMouseDown}
	style={`height:${height}px;width:${height}px`}
>
	{#if isSoundOn}
		<Sound />
	{:else}
		<SoundMute />
	{/if}
</div>

<style>
	div {
		cursor: pointer;
	}
</style>
